module.exports = __webpack_public_path__ + "img/bactech.a77732f7.png";